import { TemplatePage } from './types';

const specialOfferPage: TemplatePage = {
  header: {
    color: '#FB9F54',
    icon: 'images/video-templates/special-offers-sales.jpg',
    title: 'Special Offers & Sales Video Templates',
    title_meta: '100+ Free Special Offers & Sales Video Templates',
    description_meta:
      'Customize 100+ Special Offers & Sales Templates to create attention-grabbing videos for your marketing campaigns.',
    description:
      'Create eye-catching marketing videos to promote your sales and special offers. Every template is fully ' +
      'customizable, so you can adjust the colors and messaging to match your brand. Your customers won’t resist clicking!'
  },
  footer: {
    category: 'Special Offers & Sales',
    description:
      'Don’t want to spend money and time on hiring a video production team? With Wave.video templates, creating ' +
      'videos is a breeze. Customize any template to your liking with easy editing tools and a built-in content ' +
      'library in minutes.'
  },
  content: [
    {
      type: 'templates',
      title: 'Special Offers & Sales Videos',
      search: { category: '/Use Cases/Special Offers & Sales' }
    },
    {
      type: 'stocks',
      title: 'special offers and sales',
      search: { name: 'offers' }
    },
    { type: 'calendar' }
  ]
};

export default specialOfferPage;
